<script lang="ts">
export const radialProgressCls = cva("spinner", {
	variants: {
		color: {
			default: null,
			neutral: "spinner-neutral",
			primary: "spinner-primary",
			secondary: "spinner-secondary",
			accent: "spinner-accent",
			success: "spinner-success",
			warning: "spinner-warning",
			error: "spinner-error",
		},
	},
});

type variant = VariantProps<typeof radialProgressCls>;

export interface RadialProgressProps extends ClassProps {
	color?: variant["color"];
}
</script>
<script setup lang="ts">
import { cva, type VariantProps } from "class-variance-authority";
import type { ClassProps } from "../../lib/base-props";

const props = defineProps<RadialProgressProps>();
</script>

<template>
	<div :class="radialProgressCls(props)">
		<slot />
	</div>
</template>
